/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type SinchFaxStatus =
  (typeof SinchFaxStatus)[keyof typeof SinchFaxStatus];

export const SinchFaxStatus = {
  COMPLETED: "COMPLETED",
  FAILURE: "FAILURE",
  IN_PROGRESS: "IN_PROGRESS",
  QUEUED: "QUEUED",
} as const;
